import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 500 500"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "stroke-width": "14" }, [
      _createElementVNode("path", { d: "M250 500c2.343 0 4.686-.795 6.61-2.385L463.723 328.16l-13.221-16.192-190.042 155.48V263.599h-20.92v203.85L49.496 311.967l-13.221 16.192 207.113 169.456a10.36 10.36 0 0 0 6.61 2.385M239.54 0h20.92v75.314h-20.92zM239.54 131.8h20.92v75.313h-20.92z" })
    ], -1)
  ])))
}
export default { render: render }